import { Sidebar, SubMenu, Menu, MenuItem, useProSidebar } from "react-pro-sidebar";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { Navigate, BrowserRouter, Routes, Route, Link } from "react-router-dom";

import { useSelector, useDispatch } from 'react-redux';
import * as actions from 'store/modules/auth/actions';
import firebase from "./firebaseConfig";
import { getAuth } from "firebase/auth"

import Usuario from "./pages/Usuario"
import UsuarioAdmin from "./pages/UsuarioAdmin"
import Empresa from "./pages/Empresa"
import Uf from "./pages/Uf"
import Municipio from "./pages/Municipio"
import Ciretran from "./pages/Ciretran"
import Param from "./pages/Param"
import CertificadoPendente from "./pages/CertificadoPendente"
import CertificadoValida from "./pages/CertificadoValida"
import CertificadoExpirada from "./pages/CertificadoExpirada"
import Login from "pages/Login"

import { Nav } from "./styles/GlobalStyles";

function RequireAuth({ children }) {
    const auth = useSelector(state => state.auth.isLoggedIn);

    if (!auth) {
        return <Navigate to='/' />;
    }

    return children;
}

function AlreadyLogged({ children }) {
    const auth = useSelector(state => state.auth.isLoggedIn);

    if (auth) {
        return <Navigate to='/usuario' />;
    }

    return children;
}

function App() {
    const { collapseSidebar } = useProSidebar();
    const dispatch = useDispatch();
    const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
    console.log('logado ' + isLoggedIn)
    //const pagina = useSelector(state => state.header.pagina);
  
    const handleLogout = e => {
        e.preventDefault();
        const auth = getAuth(firebase);
        auth.signOut()
        dispatch(actions.loginFailure());
    }

  return (
    <div id="app" style={({ height: "100vh" }, { display: "flex" })}>
            <BrowserRouter>
            {isLoggedIn ? (
    <Nav>
    <div
        style={{
            color: '#555',
            borderRight: '1px solid #eee',
            borderLeft: '1px solid #eee',
            background: '#ccc',
            width: '10px'
        }}
    ></div>
      <Sidebar backgroundColor='white' style={{ height: "100vh", borderRadius: '7px' }}>
      <Menu menuItemStyles={{
                        root: {
                            fontFamily: `"Radio Canada Big", sans-serif`,
                            fontWeight: 400,
                            fontStyle: 'normal',
                            fontOpticalSizing: 'auto',
                            fontSize: 14,
                            color: '#555',
                            borderTop: '1px solid #eee'
                        }
                    }}>
          <MenuItem
            icon={<MenuOutlinedIcon />}
            onClick={() => {
              collapseSidebar();
            }}
            style={{ textAlign: "center" }}
          >
            {" "}
            <h2>CRDD</h2>
          </MenuItem>

          <SubMenu icon={<HomeOutlinedIcon />} label="Administrativo">
            <Link to="/Usuario"><MenuItem icon={<PeopleOutlinedIcon />}>Usuário</MenuItem></Link>
            <Link to="/UsuarioAdmin"><MenuItem icon={<PeopleOutlinedIcon />}>Usuário Admin</MenuItem></Link>
          </SubMenu>
          <SubMenu icon={<ReceiptOutlinedIcon />} label="Geral">
            <Link to="/UF"><MenuItem icon={<ReceiptOutlinedIcon />}>UF</MenuItem></Link>
            <Link to="/Municipio"><MenuItem icon={<ReceiptOutlinedIcon />}>Município</MenuItem></Link>
            <Link to="/Param"><MenuItem icon={<ReceiptOutlinedIcon />}>Parâmetros</MenuItem></Link>
          </SubMenu>
          <SubMenu icon={<ContactsOutlinedIcon />} label="Certidão">
            <Link to="/Pedidos"><MenuItem icon={<ContactsOutlinedIcon />}>Pedidos</MenuItem></Link>
            <Link to="/Vigentes"><MenuItem icon={<ContactsOutlinedIcon />}>Vigentes</MenuItem></Link>
            <Link to="/Expiradas"><MenuItem icon={<ContactsOutlinedIcon />}>Expiradas</MenuItem></Link>
          </SubMenu>
          <MenuItem style={{ background: '#ccc' }} onClick={handleLogout}>Sair</MenuItem>
        </Menu>
      </Sidebar>
      </Nav>) : <></>}
      <Routes>
          {/* <Route exact path="/" /> */}
          <Route path='/'element={<AlreadyLogged><Login/></AlreadyLogged>} />
          <Route path="/Usuario" element={<RequireAuth><Usuario /></RequireAuth>}></Route>
          <Route path="/UsuarioAdmin" element={<RequireAuth><UsuarioAdmin /></RequireAuth>} />
          <Route path="/UF" element={<RequireAuth><Uf /></RequireAuth>}></Route>
          <Route path="/Municipio" element={<RequireAuth><Municipio /></RequireAuth>}></Route>
          <Route path="/Param" element={<RequireAuth><Param /></RequireAuth>}></Route>
          <Route path="/Pedidos" element={<RequireAuth><CertificadoPendente /></RequireAuth>}></Route>
          <Route path="/Vigentes" element={<RequireAuth><CertificadoValida /></RequireAuth>}></Route>
          <Route path="/Expiradas" element={<RequireAuth><CertificadoExpirada /></RequireAuth>}></Route>
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default App;